/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

function throttle (fn, wait) {
  let time = Date.now()
  let timeout
  return function () {
    if ((time + wait - Date.now()) < 0) {
      fn()
      time = Date.now()
    } else {
      if (timeout) {
        clearTimeout(timeout)
      }
      timeout = setTimeout(function () {
        timeout = null
        fn()
      }, wait)
    }
  }
}

window.hasToc = false
window.tocOffsets = []
window.tocIsSticky = false
window.tocWindowHeight = 0

function tocScrollToPos (offset) {
  const timeout = 200 + Math.round(Math.abs($(window).scrollTop() - offset) / 10)
  $('html, body').animate({
    scrollTop: offset
  }, timeout)

  return timeout
}

function tocScrollTo (id) {
  if (!(id in window.tocOffsets) || !window.tocOffsets[id]) {
    return
  }
  const offset = window.tocOffsets[id]()
  const timeout = tocScrollToPos(offset)
  setTimeout(updateTocIndex, timeout)
  $('.mobile-search').removeClass('open')
}

function createToc () {
  let html = ''
  let id = 0
  const $toc = $('#page-toc,#mobile-toc')

  window.tocWindowHeight = $(window).height()
  window.tocOffsets = []
  $('.block-article > h2').each(function () {
    const $el = $(this)
    const title = $el.text().trim()
    if (title.length) {
      id++
      const offset = function () {return $el.offset().top - 40 - 76}
      $el.attr('data-id', id)
      $el.attr('id', 'heading' + id)
      html += '<li id="toc' + id + '"><a href="#heading' + id + '" onclick="(event||e).preventDefault();tocScrollTo(' + id + ')">' + title + '</a></li>'
      window.tocOffsets[id] = offset
    }
  })

  if (id && $toc.length) {
    window.hasToc = true
    $toc.html('<h3>Op deze pagina</h3><ol class="nav">' + html + '</ol>')
    updateTocIndex()
  } else {
    window.hasToc = false
    $toc.empty()
  }
}

function updateTocIndex () {
  const pos = $(window).scrollTop()
  const $toc = $('#page-toc')

  if (!window.hasToc) {
    return
  }

  if (window.tocIsSticky && pos <= 394 - 136) {
    $toc.removeClass('sticky').css({width: 'auto'})
    window.tocIsSticky = false
  } else if (!window.tocIsSticky && pos > 394 - 136) {
    const width = $toc.innerWidth()
    $toc.addClass('sticky').css({width: width})
    window.tocIsSticky = true
  }

  let prevId, id
  for (id in window.tocOffsets) {
    if (!window.tocOffsets.hasOwnProperty(id)) {
      continue
    }
    const offset = window.tocOffsets[id]()
    if (offset >= pos + 1) {
      break
    }
    prevId = id
  }

  const off = prevId || id
  const $active = $('#page-toc #toc' + off)
  if (!$active.hasClass('active')) {
    $('#page-toc .active').removeClass('active')
    $active.addClass('active')
  }

  if (window.tocIsSticky) {
    const xh = $active.offset().top - $toc.offset().top
    const vh = Math.min(0, -xh + window.tocWindowHeight / 2 - 20)
    $toc.css({top: off[1] > 3 ? vh : 136})
  }
}

function resizeImages () {
  const ww = $(window).outerWidth()
  $('.block-largeimage').each(function () {
    const $el = $(this)
    const $img = $el.find('div').first()
    $img.css({width: `${ww}px`})

    const wx = $el.width()
    const delta = Math.floor((ww - wx) / -2) + 'px'
    $img.css({left: delta})
  })
  $('.block-backgroundimage').each(function () {
    const $img = $(this)
    const wx = $img.width()
    const delta = Math.floor((ww - wx) / -2) + 'px'
    $img.css({marginLeft: delta, marginRight: delta})
  })
}

$(document).ready(createToc, function () {
  $('img').on('load', createToc)
  resizeImages()
  createToc()
})
$(document).on('pjax:end', function () {
  $('img').on('load', createToc)
  resizeImages()
  createToc()
})

$(window).scroll(throttle(updateTocIndex, 100))
$(window).resize(throttle(function () {
  resizeImages()
  createToc()
}, 100))

resizeImages()
